import { yupResolver } from '@hookform/resolvers/yup'
import { Close, CopyAll } from '@mui/icons-material'
import {
  CardActions,
  CardContent,
  Divider,
  Grid,
  MenuItem,
  Skeleton,
  Typography
} from '@mui/material'
import { Button, Card, CardHeader, IconButton, Modal } from 'components'
import { FormProvider, useForm } from 'react-hook-form'
import { useCopyToClipboard, Yup } from 'utils'
import { FileUploadProvider } from 'contexts'
import { useAutentiqueModalStore } from './autentiqueLinkModalStore'
import { useCreateOrderAutentiqueLink } from './useCreateOrderAutentiqueLink'
import { toast } from 'react-toastify'
import { useEffect, useState } from 'react'
import { SignedProposals } from '../signedProposals'

const schema = Yup.object({
  // name: Yup.string().required()
})

function AutentiqueLinkModalProvided() {
  const isOpen = useAutentiqueModalStore.useIsModalOpen()
  const setIsOpenModal = useAutentiqueModalStore.useSetModalOpen()
  const proposalId = useAutentiqueModalStore.useProposalId()
  const [value, copy] = useCopyToClipboard()
  const [linkValue, setLinkValue] = useState('')

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: ''
    }
  })

  const { handleSubmit, setValue } = methods

  const { mutateAsync, isLoading, data } = useCreateOrderAutentiqueLink()

  const onClose = () => {
    setIsOpenModal(false)
  }

  const handleCopyClick = () => {
    copy(data?.data?.link.replaceAll('"', '') || '')
    toast.success('Link gerado copiado!', {
      toastId: 'copyAutentiqueLink'
    })
  }

  const onSubmit = async () => {
    try {
      const formData = new FormData()

      formData.append('proposalId', proposalId)
      formData.append('name', proposalId)

      const response = await mutateAsync(formData)
      if (response?.data?.link) {
        setLinkValue(response?.data?.link || '')
        copy(response?.data?.link)
        toast.success('Link gerado copiado!', {
          toastId: 'copyAutentiqueLink'
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    setValue('name', proposalId)
  }, [proposalId, setValue])

  return (
    <FormProvider {...methods}>
      <Modal
        open={isOpen}
        onClose={onClose}
        keepMounted={false}
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      >
        <Card style={{ padding: 0, minWidth: 300, width: 600 }}>
          <CardHeader
            title={`GERAR LINK ORÇAMENTO: ${proposalId || ''}`}
            HeaderRight={
              <IconButton onClick={() => onClose()}>
                <Close />
              </IconButton>
            }
          />
          <Divider />

          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography>
                  Clique em gerar link para enviar o pdf pelo o Autentique!
                </Typography>
              </Grid>

              {isLoading && (
                <Grid item xs={12} container alignItems="center">
                  <Grid item xs={10}>
                    <Skeleton height={30} width={350} />
                  </Grid>
                  <Grid item xs={2}>
                    <Skeleton height={30} width={100} />
                  </Grid>
                </Grid>
              )}

              {!isLoading && data?.data?.link && (
                <Grid item xs={12} container alignItems="center">
                  <Grid item xs={10}>
                    <Typography variant="h6">Link para o Autentique</Typography>
                  </Grid>

                  <Grid item xs={10}>
                    {isLoading && <Skeleton height={30} width={350} />}
                    {!isLoading && <Typography>{linkValue}</Typography>}
                  </Grid>
                  <Grid item xs={2}>
                    {isLoading && <Skeleton height={30} width={100} />}
                    {!isLoading && (
                      <MenuItem onClick={handleCopyClick}>
                        Copiar
                        <CopyAll />
                      </MenuItem>
                    )}
                  </Grid>
                </Grid>
              )}
              <Grid item xs={12}>
                <SignedProposals proposalId={proposalId} />
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardActions>
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                gap: '1rem'
              }}
            >
              <Button
                variant="text"
                sx={{
                  width: { sm: 100, md: 200 }
                }}
                onClick={() => onClose()}
              >
                Cancelar
              </Button>
              <Button
                sx={{
                  width: { sm: 100, md: 200 }
                }}
                type="button"
                disabled={isLoading}
                onClick={handleSubmit(onSubmit)}
              >
                Gerar Link
              </Button>
            </div>
          </CardActions>
        </Card>
      </Modal>
    </FormProvider>
  )
}

const AutentiqueLinkModal = () => (
  <FileUploadProvider>
    <AutentiqueLinkModalProvided />
  </FileUploadProvider>
)

export default AutentiqueLinkModal
